export const mapApiResponseToForm = (apiResponse = {}) => ({
  categories: {
    categoriesTabColor: apiResponse?.categories_bg_color,
    categoriesTextColor: apiResponse?.categories_font_color,
    categoriesToggle: apiResponse?.categorize_experiences === 1 ? true : false,
  },
  layout: {
    layout: apiResponse?.template_id?.toString(),
  },
  background: {
    bgImage: {
      editedImage: apiResponse?.bg_image_url,
    },
    bgColor: apiResponse?.bg_color,
  },
  header: {
    image: {
      editedImage: apiResponse?.image_url,
    },
    textFont: apiResponse?.header_font,
    textColor: apiResponse?.header_text_color,
    headerColor: apiResponse?.header_tab_color,
    title: apiResponse?.my_events_text,
  },
  bottomMenu: {
    listText: apiResponse?.my_events_text,
    userListText: apiResponse?.user_list_text,
    contactUsText: apiResponse?.contact_us_text,
    codesText: apiResponse?.codes_text,
    privateMessageText: apiResponse?.private_message_text,
    notificationsText: apiResponse?.inbox_text,
    userListToggle: apiResponse?.app_user_list,
    contactUsToggle: apiResponse?.contact_us,
    codesToggle: apiResponse?.qr_text_code,
    inboxToggle: apiResponse?.app_wide_private_message,
    template: apiResponse?.inbox_template_id?.toString(),
    newsFeedText: apiResponse?.news_feed_text,
    newsFeedToggle: apiResponse?.news_feed_enabled,
  },
})

export const mapFormToApi = (data = {}) => ({
  bg_color: data?.background?.bgColor,
  categories_bg_color: data?.categories?.categoriesTabColor,
  categories_font_color: data?.categories?.categoriesTextColor,
  codes_text: data?.bottomMenu?.codesText,
  contact_us_text: data?.bottomMenu?.contactUsText,
  header_font: data?.header?.textFont,
  header_tab_color: data?.header?.headerColor,
  header_text_color: data?.header?.textColor,
  inbox_text: data?.bottomMenu?.notificationsText,
  my_events_text: data?.bottomMenu?.listText,
  private_message_text: data?.bottomMenu?.privateMessageText,
  template_id: data?.layout?.layout,
  user_list_text: data?.bottomMenu?.userListText,
  ...(data?.header?.deleteImage ? { delete_image: 1 } : {}),
  ...(data?.background?.deleteBgImage ? { delete_bg_image: 1 } : {}),
})

export const required = value => (value ? undefined : "Required")
